import { default as axios } from 'axios';
export var sendSignUpData = function (api, data) {
    var headers = {
        'Content-Type': 'application/json',
    };
    return axios
        .post(api + "/api/settings/signup", data, { headers: headers }).then(function (res) {
        return res.data;
    }).catch(function (err) {
        console.log(err);
        return null;
    });
};
